import React, { useEffect, useState } from 'react'
import "./AllBlog.css"
import { useDispatch, useSelector } from 'react-redux'
import ReactPaginate from 'react-paginate'
import Card from './../../components/Card/Card';
import { Allblogs } from '../../actions/BlogAction';

const AllBlog = () => {
  const [pageNumber, setPageNumber] = useState(0)
  const { allBlog, loading } = useSelector((state) => state.blog)
  const dispatch = useDispatch()



  useEffect(() => {
    dispatch(Allblogs)
  }, [dispatch])



  const userPerPage = 6
  const pageVisited = pageNumber * userPerPage

  const displayUsers = allBlog ? allBlog.slice(pageVisited, pageVisited + userPerPage).map((val) => {
    return <Card key={val._id} val={val} />
  }) : ""
  const pageCount = allBlog ? Math.ceil(allBlog.length / userPerPage) : ""

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }
  return (
    !allBlog?.length ? <div className='no_blog_div'>no blogs</div> :
      <div>
        <div className='Card_section'>
          {
            loading ? "Loading...." : allBlog ? displayUsers : allBlog
          }
          {allBlog ?
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBtns"}
              previousLinkClassName={"previousBtn"}
              nextLinkClassName={"nextBtn"}
              disabledClassName={"paginationDisable"}
              activeClassName={"paginationActive"}
            />
            : ""
          }
        </div>
      </div>

  )
}

export default AllBlog
